var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-tabbar',{attrs:{"swipeable":"","modifier":"ios","index":_vm.index,"tabs":_vm.tabs},on:{"postchange":_vm.handleChange,"update:index":function($event){_vm.index=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }